"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["customControls"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  customControls: _propTypes.func
};

var Controls = function Controls(_ref) {
  var customControls = _ref.customControls,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return customControls ? customControls(props) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: "center",
    justifyContent: "space-between",
    my: 10,
    position: "relative",
    width: 1
  }, props));
};

Controls.propTypes = propTypes;
var _default = Controls;
exports["default"] = _default;